import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import SimpleEditGrid from '../ui/EditGrid/SimpleEditGrid.js';
import Button from '@mui/material/Button';
import UiButton from '../ui/Button';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import "../../index.css";
import {getProcessTemplates} from '../ProcessTemplate2/apiRequestService';
import {createApprovalFromTemplate} from '../NewProcess/apiRequestService';
import {getParameterByGroupCode} from '../Parameter/apiRequestService';
import { history } from '../../App';
import styles from '../../style.js';
import BasicPageComponent from '../BasicPageComponent';
import {getUsers} from '../NewProcess/apiRequestService';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {getProcessType} from '../ProcessType/apiRequestService';

class NewProcessFromTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisabled:false,
      templateName:'',
      templateDescription:'',
      processTemplate:'',
      processTemplatesList : [],
      processFile:{},
      fileUploadIconHidden:true,
      fileBytes:'',
      internalSigners:[],
      internalSignersColumns : [
        { field: 'id', hide: true },
        { field: 'userInfo',headerName:'Kullanıcı',type:'singleSelect',labelText:'Kullanıcı', width: 428,
        renderCell: (params) => (<div>{params.value.fullName}</div>),
        dataList:[],keyField:'id',valueField:'fullName'},
        { field: 'signType',headerName:'İmzalama Türü',type:'singleSelect',labelText:'İmzalama Türü', width: 428,
        renderCell: (params) => (<div>{params.value.parameterName}</div>),
        dataList:[],keyField:'parameterValue',valueField:'parameterName'},
        { field: 'recordStatus', hide: true }
      ],
      internalSignersColumnsVisiblity:{id:false,recordStatus:false},
      isSetSigner:false,
      additionalFileUploadIconHidden: true,
      additionalProcessFile: {},    
      additionalFileBytes:'',
      additionalDocRequirement: ''
    };
  }


  componentDidMount() {
    //Süreç Şablonu
    getProcessTemplates()
    .then((response) => {
      this.setState({processTemplatesList : response.data});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Süreç şablonu bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getProcessTemplates exception: ' + JSON.stringify(exception));
    }); 

    //İmzacılar
    getUsers()
    .then((response) => {
      this.state.internalSignersColumns.filter(item => item.field=="userInfo").map((item) =>
      item.dataList=response.data);
    })
    .catch((exception) => {
      this.props.actions.setNotification("İmzacı bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getUsers exception: ' + JSON.stringify(exception));
    });

    //İmzalama Türü
    getParameterByGroupCode('SIGN_TYPE')
    .then((response) => {
      this.state.internalSignersColumns.filter(item => item.field=="signType").map((item) =>{
        item.dataList=response.data;
      });
    })
    .catch((exception) => {
      this.props.actions.setNotification("İmzalama türü bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getParameterByGroupCode exception: ' + JSON.stringify(exception));
    }); 
  }

  afterDataLoaded(currentItem,processData) { 
    let field=currentItem.field;
    let dataList=currentItem.dataList;
    let keyField=currentItem.keyField;
    let valueField=currentItem.valueField;

    for (let i = 0; i < processData.length; i++) {   
      for (let y = 0; y < dataList.length; y++) {
        const element = dataList[y];
        if(element[keyField]===processData[i][field][keyField])
          processData[i][field][valueField]=element[valueField];
      }  
    }
 
  }

  processTypeChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;
    const{processTypesList}=this.state;

    for (let i = 0; i < processTypesList.length; i++) {
      if(processTypesList[i].id==fieldValue){
        this.setState({ processTypeFileName:processTypesList[i].fileUrl, additionalDocRequirement: processTypesList[i].additionalDocumentRequirement});
        break;
      }
    }

    this.setState({ [fieldName]: fieldValue });  
  };

  handleChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({ [fieldName]: fieldValue });
  };

  handleTemplateChange = event => {
    const{processTemplatesList, processTypesList}=this.state;

    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({ [fieldName]: fieldValue });

    for (let i = 0; i < processTemplatesList.length; i++) {
      let selectedValue=processTemplatesList[i];
      if (selectedValue.id === fieldValue) {
        getProcessType(selectedValue.processGroup)
        .then((response) => {
          const fetchedProcessTypes = response.data;
          this.setState({ processTypesList: fetchedProcessTypes, processType: this.guidEmpty });
      
          const matchedType = fetchedProcessTypes.find(pt => pt.id === selectedValue.processType);
          if (matchedType) {
            this.setState({ additionalDocRequirement: matchedType.additionalDocumentRequirement });
          }
        })
        .catch((exception) => {
          this.props.actions.setNotification("Süreç türü bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
          console.log('getProcessTypes exception: ' + JSON.stringify(exception));
        }); 

        _.remove(this.state.internalSignersColumns, bucketlistitem => bucketlistitem.field === "order");

        this.setState({internalSigners: selectedValue.internalSigners,isSetSigner: false});
        //İmzacılar
        this.state.internalSignersColumns.filter(item => item.field=="userInfo").map((item) =>{this.afterDataLoaded(item,selectedValue.internalSigners); });
        //İmzalama Türü
        this.state.internalSignersColumns.filter(item => item.field=="signType").map((item) =>{this.afterDataLoaded(item,selectedValue.internalSigners); });
      }
    }
  };

  handleSetSigners = () => {
    this.setState({isSetSigner: true});
  }

  fileChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.readAsArrayBuffer(file);
    reader.onloadend = () => {
      console.log('image read complete');
      const fileBytes = new Uint8Array(reader.result);
      
      const imageEncoded = btoa(fileBytes.reduce(function (data, byte) {
        return data + String.fromCharCode(byte);
    }, ''));

      this.setState({fileUploadIconHidden:false,fileBytes:fileBytes,
        processFile:{fileName:file.name,fileType:file.type,size:file.size,fileData:imageEncoded}});
    };
  }

  additionalFileChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];

    reader.readAsArrayBuffer(file);
    reader.onloadend = () => {
      console.log('image read complete');
      const additionalFileBytes = new Uint8Array(reader.result);

      const imageEncoded = btoa(additionalFileBytes.reduce(function (data, byte) {
        return data + String.fromCharCode(byte);
    }, ''));

      this.setState({additionalFileUploadIconHidden:false,additionalFileBytes:additionalFileBytes,
        additionalProcessFile:{fileName:file.name,fileType:file.type,size:file.size,fileData:imageEncoded}});
    };
  }


  fileClick = (e) => {
    e.target.value = null;
    this.setState({fileUploadIconHidden:true,processFile:{}});
  }

  additionalFileClick = (e) => {
    e.target.value = null;
    this.setState({additionalFileUploadIconHidden:true,additionalProcessFile:{}});
  }

  fileOpen = (e) => {
    const{processFile,fileBytes}=this.state;
    
    var blob = new Blob([fileBytes], { type: processFile.fileType });
    var url = URL.createObjectURL(blob);
    window.open(url);
  }

  additionalFileOpen = (e) => {
    const{additionalProcessFile,additionalFileBytes}=this.state;
    
    var blob = new Blob([additionalFileBytes], { type: additionalProcessFile.fileType });
    var url = URL.createObjectURL(blob);
    window.open(url);
  }

  handleOnGridChange(data,id) {
    this.setState({ [id]: data });
  }

  handleValidation(rows,newRow) {
    const isPresent = rows.some(item => item.userInfo.id === newRow.userInfo.id);

    if(isPresent){
      this.props.actions.setNotification('Aynı kullanıcıyı birden fazla kez tanımlayamazsınız.', 'error');
      return true;
    }
    return false;
  }

  handleSave = () => {
    const {templateName,templateDescription,processFile,processTemplate,internalSigners,isSetSigner, additionalProcessFile, additionalDocRequirement}=this.state;

    const newApproval={
      name:templateName,
      description:templateDescription,
      fileInfo:processFile,
      processTemplateId:processTemplate,
      isSignersRebuild:isSetSigner,
      internalSigners:internalSigners,
      additionalFileInfo: additionalProcessFile
    }

    //Ek doküman gerekiyorsa ama yüklenmemişse kullanıcıyı uyar
    if (additionalDocRequirement === 'Necessary' && (!additionalProcessFile || _.isEmpty(additionalProcessFile.fileData))) {
      this.props.actions.setNotification('Bu süreç türü için ek doküman yüklenmesi zorunludur.', 'warning');
      return;
    }

    this.setState({isDisabled:true});

    setTimeout(() => {
      console.log("Process Template Disabled");
      this.setState({isDisabled:false});
    },3000);

    createApprovalFromTemplate(newApproval)
    .then((responseJson) => {
      history.push('/processmanagement');
      console.log(responseJson);
    }).catch((error) => {
      if (!_.isNil(error.Message)) {
        this.props.actions.setNotification(error.Message, 'error');
      } else {
        this.props.actions.setNotification('Süreç başlatılamadı.Girmiş olduğunuz değerlerde sorun olabilir.', 'error');
      }
    })
    .finally(()=>{
      this.setState({loading: false});
    });
  };

  render() {
    const { templateName,templateDescription,processTemplate,processTemplatesList,fileUploadIconHidden,internalSigners,
      internalSignersColumns,internalSignersColumnsVisiblity,isSetSigner,processFile,isDisabled, additionalProcessFile,
      additionalFileUploadIconHidden, additionalDocRequirement} = this.state;

    return (
      <div>
      <BasicPageComponent
      children = {
      <ScreenContainer>
      <Box sx={{ width: '100%' }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

        <Grid item xs={12}>
          <Box sx={styles.boxClass}>        
            <div className="headerStyle"><h4>Süreç İşlem Tanımı</h4></div>
            <div className='row'>
            <div className="component col-12 col-sm-4" >
              <InputLabel id="template-label" style={styles.label}>Süreç Adı</InputLabel>
              <div>
              <TextField sx = {styles.textField} className="customInputText" placeholder='Süreç Adı'
              labelId="template-label" id="templateNameText" name="templateName" value={templateName} variant="outlined" onChange={this.handleChange}/>
              </div>
            </div>
            <div className="component col-12 col-sm-4" >
              <InputLabel id="templateDescription-label" style={styles.label}>Süreç Açıklama</InputLabel>
              <TextField className='customInputTextarea' style={{width: '100%'}} InputProps={styles.multiline} multiline rows={4} labelId="templateDescription-label" id="templateDescriptionText" name="templateDescription" value={templateDescription} variant="outlined" onChange={this.handleChange} placeholder="Süreç Açıklama"/>
            </div>
            </div>
            <div className="component row" >
              <div className='sameLine col-12 col-sm-4'>
                <InputLabel id="processTemplateLabel" style={styles.label}>Süreç Şablonu</InputLabel>
                <Select
                  fullWidth
                  labelId="processTemplateLabel"
                  id="processTemplateSelect"
                  className='customSelect'
                  value={processTemplate}
                  name="processTemplate"
                  style={styles.selectField}
                  onChange={this.handleTemplateChange}>
                  {processTemplatesList.map((p) => (
                    <MenuItem value={p.id}>
                      <div style={styles.selectField}>{p.name}</div>
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className='sameLine col-12 col-sm-auto' hidden={true}>
                  <Button className='imzaciDuzenleBtn' onClick={this.handleSetSigners} style={styles.showButton} variant="contained" >
                    İmzacıları Düzenle
                  </Button>
              </div>
            </div>

            
            
            <div className="headerStyle col-sm-12" >
              {/* <InputLabel id="templateDescription-label" style={styles.label}>Süreç Dosyası</InputLabel> */}
              <div>
                <input className="inputStyle" id="contained-button-file" type="file" onClick = {this.fileClick} onChange = {this.fileChange}/>
                <label htmlFor="contained-button-file">
                  <UiButton className='customFileUploadBtn' text = "Dosya Yükle" component = "span"/>
                  <img src={require('../../images/success_old.png')} alt="Succes Logo" width={40} height={40} hidden={fileUploadIconHidden}/>
                </label>
              </div>
              <div className="component col-12 col-sm-4" >
                <Box component="span" sx={{ p: 2, border: '1px dashed grey' }} hidden={fileUploadIconHidden}>
                  <Button onClick = {this.fileOpen}>{processFile.fileName}</Button>
                </Box>
              </div>  
            </div>  

            <div className="headerStyle col-sm-12" >
              {/* <InputLabel id="templateDescription-label" style={styles.label}>Süreç Dosyası</InputLabel> */}
              <div style={{display: 'flex', flexDirection: 'column'}} hidden={_.isEmpty(additionalDocRequirement)}>
                <input className="inputStyle" id="contained-button-additional-file" type="file" onClick = {this.additionalFileClick} onChange = {this.additionalFileChange}/>
                <label htmlFor="contained-button-additional-file">
                  <UiButton className='customAdditionalFileUploadBtn' text = "Ek Dosya Yükle" component = "span"/>
                  <img src={require('../../images/success_old.png')} alt="Succes Logo" width={40} height={40} hidden={additionalFileUploadIconHidden}/>
                </label>
              </div>
              <div className="component col-12 col-sm-4" >
                <Box component="span" sx={{ p: 2, border: '1px dashed grey' }} hidden={additionalFileUploadIconHidden}>
                  <Button onClick = {this.additionalFileOpen}>{additionalProcessFile.fileName}</Button>
                </Box>
              </div>   
            </div>        
          </Box>
        </Grid>

        {isSetSigner&&
        <Grid item xs={12}>
          <Box sx={styles.boxClass}>
            <div className="headerStyle"><h4>İmzacı Ekle</h4></div>
            <div className='component'>
              <SimpleEditGrid rows={internalSigners} columns={internalSignersColumns} columnVisibilityModel={internalSignersColumnsVisiblity} rowsReOrder
              gridHeight={400} 
              dialogTitle="İmzacı Ekle" 
              onGridChange = {(e) => this.handleOnGridChange(e,"internalSigners")}
              validation={(a,b)=>this.handleValidation(a,b)}/>
            </div>
          </Box>
        </Grid>}

        <Grid item xs={12}>
          <Box sx={styles.boxClass}>
            <div align="right">
            <Button onClick={this.handleSave} sx={styles.saveButton} variant="contained" disabled = {isDisabled}>
              Kaydet ve Başlat
            </Button>
            </div>
          </Box>
        </Grid>

      </Grid>
    </Box>
    </ScreenContainer>
    }
    /> 
    </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
)(NewProcessFromTemplate);